import Vue from 'vue';

import Router from 'vue-router';

import Login from './screens/auth/Login';
import Signup from './screens/auth/Signup';
import ChoosePassword from './screens/auth/ChoosePassword';
import ResetPassword from './screens/auth/ResetPassword';
import LoginCallback from './screens/auth/LoginCallback';
import OrgSelection from './screens/auth/OrgSelection';
import License from './screens/auth/License';
import EmailVerification from './screens/auth/EmailVerification';
import EmailVerifiedCallback from './screens/auth/EmailVerifiedCallback';
import AcceptInvite from './screens/auth/AcceptInvite';

import Account from './screens/account/Account';
import Profile from './screens/account/Profile';
import ChangePassword from './screens/account/ChangePassword';

import OrgManagement from './screens/org/OrgManagement';
import OrgUsers from './screens/org/OrgUsers';
import OrgProfile from './screens/org/OrgProfile';
import OrgGroups from './screens/org/OrgGroups';

import AccessManagement from './screens/access/AccessManagement';
import OrgsManagement from './screens/access/OrgsManagement';
import OrgDetailsManagement from './screens/access/OrgDetailsManagement';
import UsersManagement from './screens/access/UsersManagement';
import CasesManagement from './screens/access/CasesManagement';
import SkeletonKey from './screens/access/SkeletonKey';
import Templates from './screens/access/Templates';
import NotificationsManagement from './screens/access/NotificationsManagement';

import BillingPortal from './screens/payment/BillingPortal';
import auth from '../lib/common/providers/auth';

Vue.use(Router);

const routes = [
  {
    path: '/login',
    alias: '/',
    name: 'login',
    component: Login
  },
  {
    path: '/signup',
    name: 'signup',
    component: Signup
  },
  {
    path: '/choose-password',
    name: 'choose-password',
    component: ChoosePassword
  },
  {
    path: '/reset-password',
    name: 'reset-password',
    component: ResetPassword
  },
  {
    path: '/callback',
    name: 'callback',
    component: LoginCallback
  },
  {
    path: '/org-selection',
    name: 'org-selection',
    component: OrgSelection
  },
  {
    path: '/license',
    name: 'license',
    component: License
  },
  {
    path: '/verify',
    name: 'verifyEmail',
    component: EmailVerification
  },
  {
    path: '/emailVerified',
    name: 'emailVerifiedCallback',
    component: EmailVerifiedCallback
  },
  {
    path: '/accept-invite',
    name: 'accept-invite',
    component: AcceptInvite
  },
  {
    path: '/account',
    name: 'account',
    component: Account,
    children: [
      {
        path: '/account/profile',
        name: 'profile',
        component: Profile
      },
      {
        path: '/account/change-password',
        name: 'change-password',
        component: ChangePassword
      }
    ]
  },
  {
    path: '/org',
    name: 'org',
    component: OrgManagement,
    meta: {
      authorizedRoles: ['SUPER_ADMIN', 'ADMIN', 'USER']
    },
    children: [
      {
        path: '/org/invite/',
        name: 'invite-users',
        component: OrgUsers,
      },
      {
        path: '/org/invite-subscribed',
        name: 'invite-users',
        component: OrgUsers,
        meta: { subscribed: true }
      },
      {
        path: '/org/archived-users',
        name: 'archived-users',
        component: OrgUsers,
        meta: { archived: true }
      },
      {
        path: '/org/profile',
        name: 'org-profile',
        component: OrgProfile
      },
      {
        path: '/org/groups',
        name: 'org-groups',
        component: OrgGroups
      },
    ]
  },
  {
    path: '/groups',
    name: 'groups',
    component: AccessManagement,
    meta: {
      authorizedRoles: ['SUPER_ADMIN', 'ADMIN', 'USER']
    },
    children: [
      {
        path: '/groups/:orgId',
        name: 'group-details',
        component: OrgDetailsManagement
      },
    ]
  },
  {
    path: '/access',
    name: 'manage-access',
    component: AccessManagement,
    meta: {
      authorizedRoles: ['SUPER_ADMIN']
    },
    children: [
      {
        path: '/access/organizations',
        name: 'organizations',
        component: OrgsManagement
      },
      {
        path: '/access/organizations/:orgId',
        name: 'organization-details',
        component: OrgDetailsManagement
      },
      {
        path: '/access/users',
        name: 'users',
        component: UsersManagement
      },
      {
        path: '/access/cases',
        name: 'cases',
        component: CasesManagement
      },
      {
        path: '/access/skeleton',
        name: 'skeleton',
        component: SkeletonKey
      },
      {
        path: '/access/templates',
        name: 'templates',
        component: Templates
      },
      {
        path: '/access/notifications',
        name: 'notifications',
        component: NotificationsManagement
      }
    ]
  },
  {
    path: '/payment/portal',
    name: 'paymentPortal',
    component: BillingPortal,
  },
  // Redirects for old URLs
  {
    path: '/manage-users',
    redirect: { name: 'org' }
  },
  {
    path: '/manage-users/invite',
    redirect: { name: 'invite-users' }
  }
];

const router = new Router({
  mode: 'history',
  base: '/auth',
  routes
});


router.beforeEach((to, from, next) => {
  const user = auth.getUser();
  const { role } = user || {};
  const isAuthorized = to.matched.every((route) => {
    if (
      route.meta &&
      route.meta.authorizedRoles &&
      !route.meta.authorizedRoles.includes(role)
    ) {
      return false;
    }
    return true;
  });
  if (!isAuthorized) {
    return next({name: 'profile'});
  }
  next();
});

export default router;
